import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { QRCodeSVG } from 'qrcode.react';

import { CopySvg } from '@cashier/cashier-assets';
import { IntegrationThemes } from '@cashier/cashier-model';
import {
  useCopyToClipboard,
  useUIConfiguration,
} from '@cashier/cashier-shared';
import { Button, cn } from '@cashier/cashier-ui';

import styles from './styles.module.scss';

interface CopyableTextProperties {
  text: string;
  label: string;
  theme: IntegrationThemes;
  showQrCode: boolean;
}

export const StandardCopyableText = ({
  label,
  text,
  theme,
  showQrCode,
}: CopyableTextProperties): ReactElement => {
  const { t } = useTranslation();
  const { copyToClipboard, copied } = useCopyToClipboard();
  const buttonBackground = useUIConfiguration('button', 'background');

  return (
    <div
      className={cn({
        [styles.container]: true,
        [styles.platform]: theme === IntegrationThemes.Platform,
      })}
    >
      {showQrCode && (
        <QRCodeSVG value={text} data-test="qr-code" includeMargin />
      )}
      <br />
      {label ? (
        <div className={styles.labelWrapper}>
          <div>{label}</div>
          <div>{text}</div>
        </div>
      ) : (
        <div data-test="qr-code-data">{text}</div>
      )}
      <div className={styles.copiedMessageContainer}>
        {copied && <p className={styles.message}>{t('copied.message')}</p>}
      </div>
      <div className={styles.buttonContainer}>
        <Button
          onClick={() => copyToClipboard(text)}
          type="primary"
          backgroundType={buttonBackground}
        >
          <div className={styles.buttonWrapper} data-test="copy-button">
            <div className={styles.icon}>
              <CopySvg />
            </div>
            {t('copy.button')}
          </div>
        </Button>
      </div>
    </div>
  );
};
